// extracted by mini-css-extract-plugin
module.exports = {"modal":"AddActivityLogOnline_modal__3tPRW"};